export default "__VITE_ASSET__BL48YlUF__"